/**
 * Services de l'action `api` (58 §14.2, ADR-048 §5).
 *
 * Deux familles, et rien d'autre :
 * - **serveur** : `command:<CommandName>` ou `query:<QueryName>` de l'API v1. Le runtime ne fait que
 *   transmettre le nom et les paramètres à une {@link ServiceGateway} ; authentification, tenant de
 *   la session, politique, idempotence et audit sont ceux du serveur, jamais décidés ici ;
 * - **coquille** : liste fermée ci-dessous, exécutée par l'hôte (navigation, ouverture de vue,
 *   notification) ou par le runtime lui-même (`component.emit`). La navigation vise une cible
 *   sémantique, jamais une URL (59 §3.4, §20.2).
 */
export const SHELL_SERVICES = {
    'shell.navigate': { required: ['target'], optional: [] },
    'shell.open_view': { required: ['view_ref'], optional: ['representation', 'record_id', 'presentation'] },
    'shell.close': { required: [], optional: ['result'] },
    'shell.notify': { required: ['message'], optional: ['level'] },
    'component.emit': { required: ['output'], optional: null },
};
const SERVER_SERVICE = /^(command|query):([A-Z][A-Za-z0-9]*)$/;
export function parseService(service) {
    const server = SERVER_SERVICE.exec(service);
    if (server !== null)
        return { kind: server[1], name: server[2] };
    if (!Object.hasOwn(SHELL_SERVICES, service))
        return null;
    return { kind: service === 'component.emit' ? 'emit' : 'shell', name: service };
}
/** Catégories de l'Error Contract qui signifient « l'accès est refusé » : état `permission_denied`. */
export const DENIAL_CATEGORIES = new Set(['AUTHENTICATION_ERROR', 'AUTHORIZATION_ERROR', 'POLICY_REJECTION']);
//# sourceMappingURL=services.js.map